var _defs, _g, _g2, _line, _line2, _line3, _line4, _line5, _line6, _line7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrainstorming({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    "data-name": "Warstwa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 1280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke-width: 18px;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-width: 20px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m854.23,755c-2,0-189-8-189-8l-185,62s.87,51.33,61.43,54.66,128.57-31.66,128.57-31.66l159,148,87-57-62-168Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "829.23 980 843.23 999 790.23 1043 761.23 1076 736.84 1072.51 719.17 1101.28 684.89 1101.28 660.23 1113 396.23 943 453.23 771 598.23 729 672.18 747"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 684.89,
    y1: 1101.28,
    x2: 625.23,
    y2: 1055
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 736.84,
    y1: 1072.51,
    x2: 671.23,
    y2: 1020
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 796.93,
    y1: 1037.44,
    x2: 684.89,
    y2: 946.07
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "442.5 972.79 421.23 1005 591.23 1118 625.23 1090.46"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 462.84,
    y1: 1032.66,
    x2: 484.64,
    y2: 999.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 511.84,
    y1: 1065.66,
    x2: 533.64,
    y2: 1032.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 563.84,
    y1: 1098.66,
    x2: 585.64,
    y2: 1065.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "453.23 771 339.23 718 260.24 972.79 396.23 943"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m854.23,755l87.46-37s89.19,106,98.37,203l-123.82,2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 339.23,
    y1: 718,
    x2: -0.77,
    y2: 559.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1040.06,921l9.18,43c76.67-32,153.33-64,230-96"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 941.69,
    y1: 718,
    x2: 1279.23,
    y2: 568
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 260.24,
    y1: 972.79,
    x2: -0.77,
    y2: 879.77
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m515.62,349.69v-.03c-6.99-17.34-10.83-36.29-10.83-56.14,0-83.13,67.4-150.53,150.53-150.53s150.53,67.4,150.53,150.53c0,19.85-3.84,38.79-10.81,56.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m515.62,349.67c12.84,24.75,27.16,58.09,37.04,99.09,8.75,36.29,11.64,68.62,12.13,94.38"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 548.76,
    y: 583.2,
    width: 213.14,
    height: 40.06,
    rx: 18.34,
    ry: 18.34
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 548.76,
    y: 543.14,
    width: 213.14,
    height: 40.06,
    rx: 18.34,
    ry: 18.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m742.6,543.14c.31-27.26,3.51-63.85,15.35-105.3,10.46-36.61,24.58-66.21,37.09-88.17"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m560.37,582.29c-.08.63-.15,1.26-.22,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m565.08,623.19c12.24,38.18,48.03,65.81,90.27,65.81s77.99-27.6,90.24-65.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m748.57,583.29c0-.07,0-.13-.02-.19"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "656.26 543.14 656.26 422.55 591.26 349.69"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 656.26,
    y1: 422.55,
    x2: 715.97,
    y2: 349.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m655.33,179.98s-90.84,7.46-114.92,106.73"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 424,
    y1: 147,
    x2: 488,
    y2: 185
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 480.75,
    y1: 79.77,
    x2: 529.25,
    y2: 136.23
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 565,
    y1: 38,
    x2: 584.53,
    y2: 102.39
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 886.53,
    y1: 144,
    x2: 822.53,
    y2: 182
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 829.78,
    y1: 76.77,
    x2: 781.27,
    y2: 133.23
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 745.53,
    y1: 35,
    x2: 726,
    y2: 99.39
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 655,
    y1: 96.39,
    x2: 655,
    y2: 24.49
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainstorming);
export default __webpack_public_path__ + "static/media/brainstorming.718e9a76960a80c093b6f882465c2b2a.svg";
export { ForwardRef as ReactComponent };